export default async function retryRequest(axiosErrorConfig) {
    let retriedResponse = null;

    console.log("GETTING TOKEN");

    await axios.get('/token')
        .then(async response => {

            // Set new header for later requests
            window.axios.defaults.headers.common['X-CSRF-TOKEN'] = response.data;

            // Set token on the old request and re-try
            axiosErrorConfig.headers['X-CSRF-TOKEN'] = response.data;

            console.log("SETTING TOKEN: " + response.data);

            console.log("RESENDING REQUEST");

            await axios.request(axiosErrorConfig)
                .then((response) => {
                    retriedResponse = response;
                    console.log("RETURNING RESPONSE");
                    return response;
                })
                .finally(() => {
                    console.log("FINALLY");
            });
        });

    console.log("FUNCTION EXIT");
}
